import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopunecabs() {



const cardData =
{
  keyword: 'Goa to Pune Cabs',

  heading: 'Lotus Cab: Goa to Pune Cab Service',

  headingDescription:
    "Lotus Cabs offers reliable and affordable Goa to Pune Cabs for family travel, corporate trips, business meetings, airport transfers, student travel, sightseeing tours, holiday returns, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Goa, well-maintained vehicles, and safe long-distance highway travel, Lotus Cabs ensures a smooth, comfortable, and hassle-free journey from Goa to Pune.",


  top: 'Top Places to Visit in Pune before Traveling to Goa with Lotus Cab',

 topPlaces: [
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is Pune's most iconic historical monument and a symbol of the glorious Maratha Empire. Built in 1732 as the seat of the Peshwas, the fort features magnificent gateways, impressive architecture, landscaped gardens, and an evening light and sound show. Visitors arriving from Goa often begin their Pune sightseeing journey by exploring this famous heritage landmark."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is one of Pune's most important historical attractions, renowned for its elegant Italian architecture and its association with Mahatma Gandhi during India's freedom movement. Surrounded by beautifully maintained gardens, the palace houses a museum showcasing photographs, artifacts, and memorabilia that reflect India's rich history."
    },
    {
        title: "Dagdusheth Halwai Ganpati Temple",
        description:
            "Shreemant Dagdusheth Halwai Ganpati Temple is one of Maharashtra's most revered Lord Ganesha temples. Known for its beautifully adorned idol, vibrant festivals, and spiritual atmosphere, the temple attracts thousands of devotees and tourists every day seeking blessings and experiencing Pune's rich religious culture."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a historic hill fort closely associated with the bravery of Tanaji Malusare and Chhatrapati Shivaji Maharaj. Offering panoramic views of the Sahyadri Mountains, traditional local food, and exciting trekking opportunities, the fort is a favorite destination for history enthusiasts and nature lovers."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a picturesque destination on the outskirts of Pune, known for its peaceful reservoir, scenic landscapes, and relaxing atmosphere. Families and travelers often visit during the evening to enjoy beautiful sunset views, local snacks, and quality time amidst nature."
    },
    {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum showcases one of India's finest collections of traditional artifacts, antique furniture, musical instruments, sculptures, paintings, and household items. The museum provides visitors with an enriching glimpse into India's artistic, cultural, and historical heritage."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an ancient 8th-century rock-cut Shiva temple located in the heart of Pune. Famous for its remarkable stone carvings, peaceful surroundings, and unique cave architecture, it remains an important religious and historical attraction for visitors exploring the city."
    },
    {
        title: "Rajiv Gandhi Zoological Park",
        description:
            "Rajiv Gandhi Zoological Park is a popular family attraction featuring a wide variety of wildlife, reptiles, birds, and a dedicated snake park. The well-maintained park offers educational and recreational experiences, making it an excellent destination for children and wildlife enthusiasts."
    },
    {
        title: "Pashan Lake",
        description:
            "Pashan Lake is a serene urban lake known for its peaceful walking trails, migratory birds, and natural surroundings. Birdwatchers, photographers, and morning walkers frequently visit this scenic location to enjoy a refreshing escape from the city's busy lifestyle."
    },
    {
        title: "Phoenix Marketcity Pune",
        description:
            "Phoenix Marketcity is one of Pune's largest shopping and entertainment destinations, offering premium retail stores, restaurants, cafés, multiplex cinemas, gaming zones, and family entertainment. Visitors arriving from Goa often choose the mall for shopping, dining, and leisure before completing their Pune trip."
    }
],

  "services": [
    {
      "name": "Goa to Pune Cab Service",
      "description": "Book Goa to Pune cab service for comfortable long-distance intercity travel covering approximately 450 km via NH66 or ghat routes. Available for one-way drop, round trip, and multi-day return plans. AC sedan, SUV, Ertiga, and Innova Crysta options provide flexibility based on group size and luggage requirements. Professional drivers experienced in highway and mountain driving ensure safe and smooth travel. Transparent per kilometer pricing includes base fare, toll charges, and driver allowance. Ideal for tourists returning from beach holidays, business travelers, and corporate clients."
    },
    {
      "name": "Goa to Pune One Way Cab",
      "description": "Affordable Goa to Pune one way cab option for travelers not returning to Goa. Pay only for single-side distance without round-trip billing. Suitable for airport transfers, relocation travel, and extended stays in Pune. Vehicles are well-maintained for long highway journeys. Transparent fare estimation helps in planning travel budget effectively."
    },
    {
      "name": "Goa to Pune Round Trip Taxi",
      "description": "Round trip taxi from Goa to Pune available with flexible return timing for business visits or short weekend trips. Multi-day rental plans offer convenience and reduce last-minute booking stress. AC vehicles ensure comfort during long-distance coastal and ghat travel. Clear fare structure ensures predictable pricing."
    },
    {
      "name": "North Goa to Pune Cab",
      "description": "Direct North Goa to Pune cab service covering Baga, Calangute, Candolim, and Anjuna areas. Doorstep pickup available from hotels, resorts, and private villas. Experienced drivers ensure safe highway travel. Suitable for family and group travel."
    },
    {
      "name": "South Goa to Pune Taxi",
      "description": "South Goa to Pune taxi service covering Colva, Benaulim, Palolem, and Madgaon regions. Comfortable AC vehicles provide smooth intercity travel. Ideal for tourists completing beach vacations."
    },
    {
      "name": "Goa Airport to Pune Cab",
      "description": "Convenient Goa Airport to Pune cab service for direct long-distance transfer from Dabolim or Mopa Airport. Timely pickup and luggage support ensure hassle-free departure."
    },
    {
      "name": "Goa to Pune Innova Cab",
      "description": "Premium Innova Crysta cab from Goa to Pune offering spacious seating and enhanced comfort for families and corporate groups. Ideal for long-distance highway travel."
    },
    {
      "name": "Cheap Goa to Pune Cab",
      "description": "Budget-friendly Goa to Pune cab options available without compromising safety or comfort. Suitable for students and small families seeking economical intercity travel."
    }
  ],

  "tableData": [
    ["Goa to Pune Cab Service", "Goa to Pune One Way Cab"],
    ["Goa to Pune Round Trip Taxi", "North Goa to Pune Cab"],
    ["South Goa to Pune Taxi", "Goa Airport to Pune Cab"],
    ["Goa to Pune Innova Cab", "Cheap Goa to Pune Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Safe Long-Distance Travel",
      "WhyChoosedescription": "Experienced drivers ensure secure and smooth highway travel from Goa to Pune."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure with detailed fare breakdown and no hidden charges."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Flexibility",
      "WhyChoosedescription": "Flexible booking options suitable for vacation returns or business travel."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Categories",
      "WhyChoosedescription": "Sedan, SUV, Ertiga, Innova Crysta, and luxury cab options available."
    },
    {
      "WhyChooseheading": "Airport Pickup Available",
      "WhyChoosedescription": "Direct pickup from Goa Airport with timely departure."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained vehicles ensure relaxed long-distance travel."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Trained drivers experienced in ghat and coastal highway routes."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking confirmation and fare queries."
    }
  ]
}







const faqData = [
  {
    question: 'Does Lotus Cab provide Goa to Pune cab service?',
    answer: 'Yes, Lotus Cab offers reliable Goa to Pune cab services for one-way and round trips with professional drivers and comfortable long-distance vehicles.',
  },
  {
    question: 'What is the distance between Goa and Pune by cab?',
    answer: 'The distance from Goa to Pune is approximately 440–460 km depending on the route. Travel time usually takes around 8 to 10 hours.',
  },
  {
    question: 'What are the charges for Goa to Pune cab booking?',
    answer: 'Cab charges depend on vehicle type, trip type (one-way or round trip), and travel date. Lotus Cab provides competitive per km pricing with clear and transparent billing.',
  },
  {
    question: 'Can I book a one-way Goa to Pune cab?',
    answer: 'Yes, Lotus Cab offers affordable one-way Goa to Pune cab services, allowing customers to pay only for the drop without return fare.',
  },
  {
    question: 'Which vehicles are available for Goa to Pune travel?',
    answer: 'We provide Sedan cars like Dzire and Etios for individual travelers and SUVs like Ertiga and Innova Crysta for families and group travel.',
  },
  {
    question: 'Is Goa to Pune cab service suitable after airport arrival?',
    answer: 'Yes, Lotus Cab offers direct pickup from Goa Airport and major hotels for comfortable transfer to Pune.',
  },
  {
    question: 'Are toll and state border charges included in the fare?',
    answer: 'Toll, parking, and state border taxes are charged separately as per actuals. Lotus Cab ensures full pricing transparency before booking confirmation.',
  },
  {
    question: 'Is night travel available from Goa to Pune?',
    answer: 'Yes, Lotus Cab provides safe and secure night travel options with experienced drivers for long-distance highway routes.',
  },
  {
    question: 'Can I book a round trip for Goa to Pune and return?',
    answer: 'Absolutely. We offer flexible round trip packages for customers planning return travel between Goa and Pune.',
  },
  {
    question: 'How can I book Goa to Pune cab service with Lotus Cab?',
    answer: 'You can book by sharing your pickup location in Goa, travel date, number of passengers, and vehicle preference to receive instant fare details and confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Naik',
    feedback: 'Booked Lotus Cab for Goa to Pune return after vacation. The journey was smooth and the driver handled highway roads very well. Excellent service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Very comfortable Goa to Pune cab ride with Lotus Cab. Clean vehicle, transparent pricing, and punctual pickup from our hotel.',
    rating: 5,
  },
];










































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa to Pune Cabs",
"image": "https://lotuscab.com/assets/images/goa-to-pune-cabs.jpg",
"description": "Book Goa to Pune Cabs with Lotus Cab for safe, comfortable, and affordable long-distance travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7021"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-to-pune-cabs"
}
};




  return (
    <div>
      




<Helmet>
  <title>Goa to Pune Cabs | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa to Pune Cabs with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, 24x7 support, and instant booking confirmation for a comfortable long-distance journey."
/>

<meta
 name="keywords"
 content="Goa to Pune Cabs, Goa to Pune Taxi, Goa to Pune Cab Service, Pune Cab from Goa, One Way Cab Goa to Pune, Round Trip Cab Goa to Pune, Outstation Cab Goa to Pune, Long Distance Cab Goa to Pune, Goa Airport to Pune Cab, Affordable Goa to Pune Cab, Cheap Goa to Pune Taxi, Online Goa to Pune Cab Booking, Sedan Cab Goa to Pune, SUV Cab Goa to Pune, Best Goa to Pune Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopunecabs;